/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import Hero from "components/Hero";
import useAuth from "../hooks/useAuth";
import { useMarketplaceContract, usePunkContract } from "hooks/useContract";
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import PunkCard from "components/PunkCard";
import Masonry from "react-masonry-css";
import Select from "react-select";

const MyPunks = () => {
  const { active, account } = useAuth();

  const contract = usePunkContract();
  const marketplace = useMarketplaceContract();
  const [punks, setPunks] = useState([]);
  const [filteredPunks, setFilteredPunks] = useState([]);
  const [filters, setFilters] = useState({ rarity: null, traits: [] });

  useEffect(() => {
    if (!contract || !marketplace) return;
    let ordereds = [];
    contract
      .getOwnerNFTs(account)
      .then(async (punks) => {
        const onSale = await marketplace.viewAsksByCollectionAndSeller(
          contract.address,
          account,
          0,
          10000
        );

        ordereds = [
          ...onSale.tokenIds.map((i, index) => {
            return {
              id: i.toNumber(),
              info: onSale.askInfo[index],
            };
          }),
        ];

        return [...punks, ...onSale.tokenIds];
      })
      .then((punks) => {
        const ids = [];

        punks.map((punk) => {
          ids.push(punk.toString());
        });

        axios
          .post(`${process.env.REACT_APP_BACKEND_URL}/punks`, {
            ids: ids.sort((a, b) => {
              return a - b;
            }),
          })
          .then((result) => result.data)
          .then((punks: any) => {
            setPunks(
              punks.map((punk) => {
                punk.owner = account;
                const ordered = ordereds.find((p) => p.id === punk.id);

                if (ordered) {
                  punk.onSale = true;
                  punk.info = ordered.info;
                }
                return punk;
              })
            );
            setFilteredPunks(punks);
          })

          .catch((err) => console.error(err));
      })
      .catch((err) => console.error(err));
  }, [account]);

  const gemsOptions = useMemo(() => {
    const options = [
      {
        rarity: 1,
        count: 0,
      },
      {
        rarity: 2,
        count: 0,
      },
      {
        rarity: 3,
        count: 0,
      },
      {
        rarity: 4,
        count: 0,
      },
      {
        rarity: 5,
        count: 0,
      },
    ];
    punks.map((punk) => {
      let rarityCount = 0;
      const { rank } = punk;

      if (rank <= 100) rarityCount = 5;
      else if (rank > 100 && rank <= 500) rarityCount = 4;
      else if (rank > 500 && rank <= 2500) rarityCount = 3;
      else if (rank > 2500 && rank <= 5000) rarityCount = 2;
      else rarityCount = 1;

      const exist = options.find((option) => option.rarity === rarityCount);
      if (exist) {
        exist.count++;
      } else {
        options.push({
          rarity: rarityCount,
          count: 1,
        });
      }
    });
    return options;
  }, [punks]);

  const traitsOptions = useMemo(() => {
    const options = [];

    let traits = [];
    punks.map(({ traits: t }) => {
      traits = [...traits, ...t];
    });
    for (let i = 0; i < punks.length; i++) {
      const { traits: t } = punks[i];
      t.map((trait) => {
        const exist = options.find((t) => t.trait_value === trait.trait_value);

        if (exist) {
          exist.count++;
        } else {
          options.push({ ...trait, count: 1 });
        }
      });
    }
    return options;
  }, [punks]);

  const filterPunks = (data, input) => {
    const { name } = input;

    const tmpFilter = { ...filters };
    if (name === "rarity") {
      tmpFilter.rarity = data.value;
    } else {
      tmpFilter.traits = data.map((input) => input.value);
    }
    setFilters(tmpFilter);
  };

  useEffect(() => {
    if (!filters.rarity && filters.traits.length === 0) {
      setFilteredPunks(punks);
      return;
    }

    const filtered = punks
      .filter(({ rank }) => {
        const { rarity } = filters;

        if (!rarity) return true;
        else if (rarity === 5 && rank <= 100) return true;
        else if (rarity === 4 && rank > 100 && rank <= 500) return true;
        else if (rarity === 3 && rank > 500 && rank <= 2500) return true;
        else if (rarity === 2 && rank > 2500 && rank <= 5000) return true;
        else if (rarity === 1 && rank > 5000) return true;
        else return false;
      })
      .filter(({ traits }) => {
        let found = false;
        const { traits: filteredTraits } = filters;
        if (filteredTraits.length === 0) return true;
        filteredTraits.map((trait) => {
          const hasTrait = traits.find((t) => t.trait_value === trait);

          if (hasTrait) {
            found = true;
          }
        });

        return found;
      });

    setFilteredPunks(filtered);
  }, [filters]);

  return (
    <div className="bg-primary text-white font-main tracking-wider">
      <Hero>
        <h1 className="text-6xl text-center w-full mt-20">My punks</h1>
        <form className="mt-10 mb-12 flex w-full">
          <label className="mx-2 w-full max-w-60">
            <span className="mb-2 block">Rarity:</span>
            <Select
              onChange={filterPunks}
              name="rarity"
              className="text-black backgrounx-transparent"
              options={[
                { value: null, label: "None" },
                ...gemsOptions.map(({ rarity, count }) => {
                  let label = "";
                  for (let i = 0; i < rarity; i++) {
                    label += "💎";
                  }
                  label += ` (${count})`;
                  return {
                    label,
                    value: rarity,
                  };
                }),
              ]}
            />
          </label>
          <label className="mx-2 w-full max-w-60">
            <span className="block mb-2">Traits:</span>
            <Select
              onChange={filterPunks}
              isMulti
              name=""
              className="text-black background-transparent"
              options={traitsOptions.map(({ trait_value, count }) => {
                return {
                  label: `${trait_value} (${count})`,
                  value: trait_value,
                };
              })}
            />
          </label>
        </form>
        {active && (
          <div className="w-full">
            <Masonry
              breakpointCols={{
                default: 3,
                1000: 2,
                500: 1,
              }}
              className="my-masonry-grid w-full"
              columnClassName="my-masonry-grid_column"
            >
              {filteredPunks.map((punk) => {
                punk.rarity = punk.rank;

                return (
                  <div className=" p-2">
                    <PunkCard
                      listPage={true}
                      className="opacity-100-important"
                      punk={punk}
                    />
                  </div>
                );
              })}
            </Masonry>
          </div>
        )}
      </Hero>
    </div>
  );
};

export default MyPunks;
